// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__NYemt","description":"MealItem_description__AnDt2","price":"MealItem_price__MZwg+"};